import { useSelector } from 'react-redux';

// Enums
import { FEATURE_FLAGS } from '@/enums/FeatureFlags';

// Hooks
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

// Utils
import { userHasPermission, PERMISSIONS } from '@/utils/permissions';

// Types
import { ReduxState } from '@/redux/modules/types';

/**
 * Hook to determine if the enhanced screener should be used.
 * Encapsulates the permission and feature flag checks.
 */
const useEnhancedScreener = () => {
  const user = useSelector((state: ReduxState) => state.auth.user);
  const { isFFEnabled } = useFeatureFlag();

  const hasEnhancedScreenerPermission = user && userHasPermission(user, PERMISSIONS.ENHANCED_SCREENER);
  const isFeatureFlagEnabled = isFFEnabled(FEATURE_FLAGS.ENHANCED_SCREENER_ENABLED);
  const shouldUseEnhancedScreener = hasEnhancedScreenerPermission && isFeatureFlagEnabled;

  return {
    user,
    shouldUseEnhancedScreener,
  };
};

export default useEnhancedScreener;
